// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as OrderRoutes from "../Order/OrderRoutes.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Form__Status from "../../bundles/Form/Form__Status.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as TableDateCell from "../../resources/tables/TableDateCell.res.js";
import * as Client from "@apollo/client";
import * as ValueIndicator from "../../resources/data-visualizations/ValueIndicator.res.js";
import * as AmountTableCell from "../../modules/TableCell/AmountTableCell.res.js";
import * as ShowAllDataLink from "../../resources/navigation/ShowAllDataLink.res.js";
import * as SupplierCivility from "../../modules/Supplier/SupplierCivility.res.js";
import * as OrderStatusBadges from "../../modules/Order/OrderStatusBadges.res.js";
import * as OrderTableActions from "../../modules/Order/OrderTableActions.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OrderNameTableCell from "../../modules/Order/OrderNameTableCell.res.js";
import * as OrderUrlQueryString from "../../modules/Order/OrderUrlQueryString.res.js";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
import * as SupplierArchiveModal from "../../modules/Supplier/SupplierArchiveModal.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["query SupplierShowPageQuery($id: ID!, $ordersFirst: Int)  {\nsupplier(id: $id)  {\n__typename  \nid  \ncompanyName  \nupdatedAt  \narchivedAt  \nintraCommunityVat  \ninternalCode  \nphoneNumber  \nmobileNumber  \nemail  \nnote  \nsiretNumber  \nformattedOrdersTotalAmountIncludingTaxes  \nshop  {\n__typename  \nid  \nname  \n}\n\ncontacts  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nposition  \ncivility  \nfirstName  \nlastName  \nformattedName  \nmobileNumber  \nphoneNumber  \nemail  \n}\n\n}\n\n}\n\nlocations  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nlabel  \nrecipient  \naddress  \npostalCode  \ncity  \ncountry  \n}\n\n}\n\n}\n\norders(first: $ordersFirst)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedStatus  \nformattedName  \nestimatedReceptionDate  \nreceptionFinishedAt  \ntotalAmountExcludingTaxes  \ntotalAmountIncludingTaxes  \ntotalProductsQuantity  \nshop  {\n__typename  \nname  \n}\n\n}\n\n}\n\npageInfo  {\n__typename  \nhasNextPage  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.supplier;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.archivedAt;
    let value$3 = value$1.intraCommunityVat;
    let value$4 = value$1.internalCode;
    let value$5 = value$1.phoneNumber;
    let value$6 = value$1.mobileNumber;
    let value$7 = value$1.email;
    let value$8 = value$1.note;
    let value$9 = value$1.siretNumber;
    let value$10 = value$1.shop;
    let value$11 = value$1.contacts;
    let value$12 = value$11.edges;
    let value$13 = value$1.locations;
    let value$14 = value$13.edges;
    let value$15 = value$1.orders;
    let value$16 = value$15.edges;
    let value$17 = value$15.pageInfo;
    let value$18 = value$17.hasNextPage;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      companyName: value$1.companyName,
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt),
      archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
      intraCommunityVat: !(value$3 == null) ? value$3 : undefined,
      internalCode: !(value$4 == null) ? value$4 : undefined,
      phoneNumber: !(value$5 == null) ? value$5 : undefined,
      mobileNumber: !(value$6 == null) ? value$6 : undefined,
      email: !(value$7 == null) ? value$7 : undefined,
      note: !(value$8 == null) ? Scalar.Text.parse(value$8) : undefined,
      siretNumber: !(value$9 == null) ? value$9 : undefined,
      formattedOrdersTotalAmountIncludingTaxes: value$1.formattedOrdersTotalAmountIncludingTaxes,
      shop: {
        __typename: value$10.__typename,
        id: value$10.id,
        name: value$10.name
      },
      contacts: {
        __typename: value$11.__typename,
        edges: value$12.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.position;
          let value$3 = value$1.civility;
          let tmp;
          if (value$3 == null) {
            tmp = undefined;
          } else {
            let tmp$1;
            switch (value$3) {
              case "MR" :
                tmp$1 = "MR";
                break;
              case "MRS" :
                tmp$1 = "MRS";
                break;
              case "NEUTRAL" :
                tmp$1 = "NEUTRAL";
                break;
              default:
                throw {
                  RE_EXN_ID: "Not_found",
                  Error: new Error()
                };
            }
            tmp = tmp$1;
          }
          let value$4 = value$1.firstName;
          let value$5 = value$1.mobileNumber;
          let value$6 = value$1.phoneNumber;
          let value$7 = value$1.email;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              position: !(value$2 == null) ? value$2 : undefined,
              civility: tmp,
              firstName: !(value$4 == null) ? value$4 : undefined,
              lastName: value$1.lastName,
              formattedName: value$1.formattedName,
              mobileNumber: !(value$5 == null) ? value$5 : undefined,
              phoneNumber: !(value$6 == null) ? value$6 : undefined,
              email: !(value$7 == null) ? value$7 : undefined
            }
          };
        })
      },
      locations: {
        __typename: value$13.__typename,
        edges: value$14.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.recipient;
          let value$3 = value$1.address;
          let value$4 = value$1.postalCode;
          let value$5 = value$1.city;
          let value$6 = value$1.country;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              label: value$1.label,
              recipient: !(value$2 == null) ? value$2 : undefined,
              address: !(value$3 == null) ? value$3 : undefined,
              postalCode: !(value$4 == null) ? value$4 : undefined,
              city: !(value$5 == null) ? value$5 : undefined,
              country: !(value$6 == null) ? value$6 : undefined
            }
          };
        })
      },
      orders: {
        __typename: value$15.__typename,
        edges: value$16.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.formattedStatus;
          let value$3 = value$1.receptionFinishedAt;
          let value$4 = value$1.shop;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id,
              formattedStatus: value$2.map(value => {
                switch (value) {
                  case "ACCEPTED" :
                    return "ACCEPTED";
                  case "ARCHIVED" :
                    return "ARCHIVED";
                  case "DRAFT" :
                    return "DRAFT";
                  case "FINALIZED" :
                    return "FINALIZED";
                  case "NOT_RECEIVED" :
                    return "NOT_RECEIVED";
                  case "PAID" :
                    return "PAID";
                  case "RECEIVED" :
                    return "RECEIVED";
                  case "RECEIVING" :
                    return "RECEIVING";
                  case "REFUSED" :
                    return "REFUSED";
                  case "SENT" :
                    return "SENT";
                  case "TO_PAY" :
                    return "TO_PAY";
                  default:
                    throw {
                      RE_EXN_ID: "Not_found",
                      Error: new Error()
                    };
                }
              }),
              formattedName: value$1.formattedName,
              estimatedReceptionDate: Scalar.Datetime.parse(value$1.estimatedReceptionDate),
              receptionFinishedAt: !(value$3 == null) ? Scalar.Datetime.parse(value$3) : undefined,
              totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
              totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
              totalProductsQuantity: value$1.totalProductsQuantity,
              shop: {
                __typename: value$4.__typename,
                name: value$4.name
              }
            }
          };
        }),
        pageInfo: {
          __typename: value$17.__typename,
          hasNextPage: !(value$18 == null) ? value$18 : undefined
        }
      }
    };
  }
  return {
    supplier: tmp
  };
}

function serialize(value) {
  let value$1 = value.supplier;
  let supplier;
  if (value$1 !== undefined) {
    let value$2 = value$1.orders;
    let value$3 = value$2.pageInfo;
    let value$4 = value$3.hasNextPage;
    let hasNextPage = value$4 !== undefined ? value$4 : null;
    let value$5 = value$3.__typename;
    let pageInfo = {
      __typename: value$5,
      hasNextPage: hasNextPage
    };
    let value$6 = value$2.edges;
    let edges = value$6.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.shop;
      let value$3 = value$2.name;
      let value$4 = value$2.__typename;
      let shop = {
        __typename: value$4,
        name: value$3
      };
      let value$5 = value$1.totalProductsQuantity;
      let value$6 = value$1.totalAmountIncludingTaxes;
      let value$7 = value$1.totalAmountExcludingTaxes;
      let value$8 = value$1.receptionFinishedAt;
      let receptionFinishedAt = value$8 !== undefined ? Scalar.Datetime.serialize(value$8) : null;
      let value$9 = value$1.estimatedReceptionDate;
      let value$10 = Scalar.Datetime.serialize(value$9);
      let value$11 = value$1.formattedName;
      let value$12 = value$1.formattedStatus;
      let formattedStatus = value$12.map(value => {
        if (value === "TO_PAY") {
          return "TO_PAY";
        } else if (value === "DRAFT") {
          return "DRAFT";
        } else if (value === "NOT_RECEIVED") {
          return "NOT_RECEIVED";
        } else if (value === "REFUSED") {
          return "REFUSED";
        } else if (value === "FINALIZED") {
          return "FINALIZED";
        } else if (value === "ACCEPTED") {
          return "ACCEPTED";
        } else if (value === "PAID") {
          return "PAID";
        } else if (value === "RECEIVING") {
          return "RECEIVING";
        } else if (value === "SENT") {
          return "SENT";
        } else if (value === "RECEIVED") {
          return "RECEIVED";
        } else {
          return "ARCHIVED";
        }
      });
      let value$13 = value$1.id;
      let value$14 = value$1.__typename;
      let node = {
        __typename: value$14,
        id: value$13,
        formattedStatus: formattedStatus,
        formattedName: value$11,
        estimatedReceptionDate: value$10,
        receptionFinishedAt: receptionFinishedAt,
        totalAmountExcludingTaxes: value$7,
        totalAmountIncludingTaxes: value$6,
        totalProductsQuantity: value$5,
        shop: shop
      };
      let value$15 = value.__typename;
      return {
        __typename: value$15,
        node: node
      };
    });
    let value$7 = value$2.__typename;
    let orders = {
      __typename: value$7,
      edges: edges,
      pageInfo: pageInfo
    };
    let value$8 = value$1.locations;
    let value$9 = value$8.edges;
    let edges$1 = value$9.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.country;
      let country = value$2 !== undefined ? value$2 : null;
      let value$3 = value$1.city;
      let city = value$3 !== undefined ? value$3 : null;
      let value$4 = value$1.postalCode;
      let postalCode = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.address;
      let address = value$5 !== undefined ? value$5 : null;
      let value$6 = value$1.recipient;
      let recipient = value$6 !== undefined ? value$6 : null;
      let value$7 = value$1.label;
      let value$8 = value$1.__typename;
      let node = {
        __typename: value$8,
        label: value$7,
        recipient: recipient,
        address: address,
        postalCode: postalCode,
        city: city,
        country: country
      };
      let value$9 = value.__typename;
      return {
        __typename: value$9,
        node: node
      };
    });
    let value$10 = value$8.__typename;
    let locations = {
      __typename: value$10,
      edges: edges$1
    };
    let value$11 = value$1.contacts;
    let value$12 = value$11.edges;
    let edges$2 = value$12.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.email;
      let email = value$2 !== undefined ? value$2 : null;
      let value$3 = value$1.phoneNumber;
      let phoneNumber = value$3 !== undefined ? value$3 : null;
      let value$4 = value$1.mobileNumber;
      let mobileNumber = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.formattedName;
      let value$6 = value$1.lastName;
      let value$7 = value$1.firstName;
      let firstName = value$7 !== undefined ? value$7 : null;
      let value$8 = value$1.civility;
      let civility = value$8 !== undefined ? (
          value$8 === "MR" ? "MR" : (
              value$8 === "MRS" ? "MRS" : "NEUTRAL"
            )
        ) : null;
      let value$9 = value$1.position;
      let position = value$9 !== undefined ? value$9 : null;
      let value$10 = value$1.__typename;
      let node = {
        __typename: value$10,
        position: position,
        civility: civility,
        firstName: firstName,
        lastName: value$6,
        formattedName: value$5,
        mobileNumber: mobileNumber,
        phoneNumber: phoneNumber,
        email: email
      };
      let value$11 = value.__typename;
      return {
        __typename: value$11,
        node: node
      };
    });
    let value$13 = value$11.__typename;
    let contacts = {
      __typename: value$13,
      edges: edges$2
    };
    let value$14 = value$1.shop;
    let value$15 = value$14.name;
    let value$16 = value$14.id;
    let value$17 = value$14.__typename;
    let shop = {
      __typename: value$17,
      id: value$16,
      name: value$15
    };
    let value$18 = value$1.formattedOrdersTotalAmountIncludingTaxes;
    let value$19 = value$1.siretNumber;
    let siretNumber = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.note;
    let note = value$20 !== undefined ? Scalar.Text.serialize(value$20) : null;
    let value$21 = value$1.email;
    let email = value$21 !== undefined ? value$21 : null;
    let value$22 = value$1.mobileNumber;
    let mobileNumber = value$22 !== undefined ? value$22 : null;
    let value$23 = value$1.phoneNumber;
    let phoneNumber = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.internalCode;
    let internalCode = value$24 !== undefined ? value$24 : null;
    let value$25 = value$1.intraCommunityVat;
    let intraCommunityVat = value$25 !== undefined ? value$25 : null;
    let value$26 = value$1.archivedAt;
    let archivedAt = value$26 !== undefined ? Scalar.Datetime.serialize(value$26) : null;
    let value$27 = value$1.updatedAt;
    let value$28 = Scalar.Datetime.serialize(value$27);
    let value$29 = value$1.companyName;
    let value$30 = value$1.id;
    let value$31 = value$1.__typename;
    supplier = {
      __typename: value$31,
      id: value$30,
      companyName: value$29,
      updatedAt: value$28,
      archivedAt: archivedAt,
      intraCommunityVat: intraCommunityVat,
      internalCode: internalCode,
      phoneNumber: phoneNumber,
      mobileNumber: mobileNumber,
      email: email,
      note: note,
      siretNumber: siretNumber,
      formattedOrdersTotalAmountIncludingTaxes: value$18,
      shop: shop,
      contacts: contacts,
      locations: locations,
      orders: orders
    };
  } else {
    supplier = null;
  }
  return {
    supplier: supplier
  };
}

function serializeVariables(inp) {
  let a = inp.ordersFirst;
  return {
    id: inp.id,
    ordersFirst: a !== undefined ? a : undefined
  };
}

function makeVariables(id, ordersFirst, param) {
  return {
    id: id,
    ordersFirst: ordersFirst
  };
}

let SupplierQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let SupplierQuery_refetchQueryDescription = include.refetchQueryDescription;

let SupplierQuery_useLazy = include.useLazy;

let SupplierQuery_useLazyWithVariables = include.useLazyWithVariables;

let SupplierQuery = {
  SupplierQuery_inner: SupplierQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: SupplierQuery_refetchQueryDescription,
  use: use,
  useLazy: SupplierQuery_useLazy,
  useLazyWithVariables: SupplierQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation SupplierEditNoteMutation($id: ID!, $supplierInput: InputUpdateSupplier!)  {\nupdateSupplier(id: $id, supplierInput: $supplierInput)  {\n__typename  \nid  \nnote  \nupdatedAt  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.updateSupplier;
  let value$2 = value$1.note;
  return {
    updateSupplier: {
      __typename: value$1.__typename,
      id: value$1.id,
      note: !(value$2 == null) ? Scalar.Text.parse(value$2) : undefined,
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt)
    }
  };
}

function serialize$1(value) {
  let value$1 = value.updateSupplier;
  let value$2 = value$1.updatedAt;
  let value$3 = Scalar.Datetime.serialize(value$2);
  let value$4 = value$1.note;
  let note = value$4 !== undefined ? Scalar.Text.serialize(value$4) : null;
  let value$5 = value$1.id;
  let value$6 = value$1.__typename;
  let updateSupplier = {
    __typename: value$6,
    id: value$5,
    note: note,
    updatedAt: value$3
  };
  return {
    updateSupplier: updateSupplier
  };
}

function serializeInputObjectInputUpdateSupplier(inp) {
  let a = inp.companyName;
  let a$1 = inp.intraCommunityVat;
  let a$2 = inp.siretNumber;
  let a$3 = inp.phoneNumber;
  let a$4 = inp.mobileNumber;
  let a$5 = inp.email;
  let a$6 = inp.note;
  let a$7 = inp.internalCode;
  return {
    companyName: a !== undefined ? a : undefined,
    intraCommunityVat: a$1 !== undefined ? a$1 : undefined,
    siretNumber: a$2 !== undefined ? a$2 : undefined,
    phoneNumber: a$3 !== undefined ? a$3 : undefined,
    mobileNumber: a$4 !== undefined ? a$4 : undefined,
    email: a$5 !== undefined ? a$5 : undefined,
    note: a$6 !== undefined ? a$6 : undefined,
    internalCode: a$7 !== undefined ? a$7 : undefined
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id,
    supplierInput: serializeInputObjectInputUpdateSupplier(inp.supplierInput)
  };
}

function makeVariables$1(id, supplierInput, param) {
  return {
    id: id,
    supplierInput: supplierInput
  };
}

function makeInputObjectInputUpdateSupplier(companyName, intraCommunityVat, siretNumber, phoneNumber, mobileNumber, email, note, internalCode, param) {
  return {
    companyName: companyName,
    intraCommunityVat: intraCommunityVat,
    siretNumber: siretNumber,
    phoneNumber: phoneNumber,
    mobileNumber: mobileNumber,
    email: email,
    note: note,
    internalCode: internalCode
  };
}

let SupplierEditNoteMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateSupplier: serializeInputObjectInputUpdateSupplier,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateSupplier: makeInputObjectInputUpdateSupplier
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let SupplierEditNoteMutation_useWithVariables = include$1.useWithVariables;

let SupplierEditNoteMutation = {
  SupplierEditNoteMutation_inner: SupplierEditNoteMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputUpdateSupplier: serializeInputObjectInputUpdateSupplier,
  makeVariables: makeVariables$1,
  makeInputObjectInputUpdateSupplier: makeInputObjectInputUpdateSupplier,
  use: use$1,
  useWithVariables: SupplierEditNoteMutation_useWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["mutation SupplierUnarchiveMutation($id: ID!)  {\nunarchiveSupplier(id: $id)  {\n__typename  \nid  \narchivedAt  \n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.unarchiveSupplier;
  let value$2 = value$1.archivedAt;
  return {
    unarchiveSupplier: {
      __typename: value$1.__typename,
      id: value$1.id,
      archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined
    }
  };
}

function serialize$2(value) {
  let value$1 = value.unarchiveSupplier;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let unarchiveSupplier = {
    __typename: value$4,
    id: value$3,
    archivedAt: archivedAt
  };
  return {
    unarchiveSupplier: unarchiveSupplier
  };
}

function serializeVariables$2(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$2(id, param) {
  return {
    id: id
  };
}

let SupplierUnarchiveMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let SupplierUnarchiveMutation_useWithVariables = include$2.useWithVariables;

let SupplierUnarchiveMutation = {
  SupplierUnarchiveMutation_inner: SupplierUnarchiveMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useWithVariables: SupplierUnarchiveMutation_useWithVariables
};

function SupplierShowPage$SupplierStatusBadge(props) {
  if (props.status === "UNARCHIVED") {
    return null;
  } else {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Archived"),
      variation: "neutral"
    });
  }
}

let SupplierStatusBadge = {
  make: SupplierShowPage$SupplierStatusBadge
};

function get(values, field) {
  return values.note;
}

function set(values, field, value) {
  return {
    note: value
  };
}

let SupplierNoteEditFormLenses_ = {
  get: get,
  set: set
};

let SupplierNoteEditFormLenses = {
  get: get,
  set: set
};

let SupplierNoteEditForm = Form.Make(SupplierNoteEditFormLenses);

function SupplierShowPage$SupplierMenuEditingActions(props) {
  let id = props.id;
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let updateSupplierNote = match[0];
  let updateSupplierNoteVariables = param => ({
    id: id,
    supplierInput: makeInputObjectInputUpdateSupplier(undefined, undefined, undefined, undefined, undefined, undefined, param.note, undefined, undefined)
  });
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(SupplierNoteEditForm.CancelButton.make, {
        label: I18n.t("Discard")
      }),
      JsxRuntime.jsx(SupplierNoteEditForm.SubmitButton.make, {
        label: I18n.t("Save"),
        tone: "success",
        onSubmit: (param, values) => Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(updateSupplierNote(undefined, undefined, undefined, undefined, undefined, undefined, undefined, updateSupplierNoteVariables(values))), undefined, param => param.updateSupplier.id)
      })
    ],
    space: "small"
  });
}

let SupplierMenuEditingActions = {
  make: SupplierShowPage$SupplierMenuEditingActions
};

function SupplierShowPage$SupplierMenuReadingActions(props) {
  let id = props.id;
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let unarchiveSupplier = match[0];
  let unarchiveSupplier$1 = param => {
    unarchiveSupplier(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id
    });
  };
  let createOrderMenuActionsItemHref = OrderRoutes.createRoute + "?" + OrderUrlQueryString.CreateOrder.encode({
    supplierId: id,
    shopId: props.shopId
  });
  if (props.status === "UNARCHIVED") {
    return JsxRuntime.jsxs(MenuActions.make, {
      children: [
        JsxRuntime.jsx(MenuActions.Section.make, {
          children: JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("New order"),
            href: createOrderMenuActionsItemHref,
            tone: "brand",
            icon: "plus_large"
          })
        }),
        JsxRuntime.jsx(MenuActions.Section.make, {
          children: JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Archive"),
            tone: "danger",
            icon: "archive",
            onAction: props.onRequestArchive
          })
        })
      ],
      trigger: {
        TAG: "Normal",
        label: I18n.t("Actions")
      }
    });
  } else {
    return JsxRuntime.jsx(Button.make, {
      label: I18n.t("Unarchive"),
      tone: "brand",
      icon: "unarchive",
      onPress: () => {
        unarchiveSupplier$1();
      }
    });
  }
}

let SupplierMenuReadingActions = {
  make: SupplierShowPage$SupplierMenuReadingActions
};

function SupplierShowPage$SupplierMenuActions(props) {
  let id = props.id;
  let formState = SupplierNoteEditForm.useFormState();
  let isFormPristine = Form__Status.isPristine(formState.status);
  let match = React.useState(() => false);
  let setArchiveModalOpened = match[1];
  let tmp;
  if (isFormPristine) {
    let onRequestArchive = () => setArchiveModalOpened(param => true);
    tmp = JsxRuntime.jsx(SupplierShowPage$SupplierMenuReadingActions, {
      id: id,
      shopId: props.shopId,
      status: props.status,
      onRequestArchive: onRequestArchive
    });
  } else {
    tmp = JsxRuntime.jsx(SupplierShowPage$SupplierMenuEditingActions, {
      id: id
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      tmp,
      JsxRuntime.jsx(SupplierArchiveModal.make, {
        id: id,
        opened: match[0],
        onRequestClose: () => setArchiveModalOpened(param => false),
        supplierBaseRoute: props.supplierBaseRoute
      })
    ]
  });
}

let SupplierMenuActions = {
  make: SupplierShowPage$SupplierMenuActions
};

function SupplierShowPage$SupplierInformationsCard(props) {
  let item = props.item;
  let email = item.email;
  let phoneNumber = item.phoneNumber;
  let mobileNumber = item.mobileNumber;
  let match = item.intraCommunityVat;
  let match$1 = item.siretNumber;
  let match$2 = item.internalCode;
  let tmp;
  let exit = 0;
  let exit$1 = 0;
  if (match !== undefined && match !== "") {
    exit = 1;
  } else {
    exit$1 = 2;
  }
  if (exit$1 === 2) {
    let exit$2 = 0;
    if (match$1 !== undefined && match$1 !== "") {
      exit = 1;
    } else {
      exit$2 = 3;
    }
    if (exit$2 === 3) {
      if (match$2 !== undefined && match$2 !== "") {
        exit = 1;
      } else {
        tmp = null;
      }
    }
  }
  if (exit === 1) {
    let intraCommunityVat = item.intraCommunityVat;
    let tmp$1;
    tmp$1 = intraCommunityVat !== undefined && intraCommunityVat !== "" ? JsxRuntime.jsxs(InlineText.make, {
        children: [
          JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("VAT n."),
            variation: "normal"
          }),
          JsxRuntime.jsx(TextStyle.make, {
            children: intraCommunityVat
          })
        ]
      }) : null;
    let siretNumber = item.siretNumber;
    let tmp$2;
    tmp$2 = siretNumber !== undefined && siretNumber !== "" ? JsxRuntime.jsxs(InlineText.make, {
        children: [
          JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Siret") + " ",
            variation: "normal"
          }),
          JsxRuntime.jsx(TextStyle.make, {
            children: siretNumber
          })
        ]
      }) : null;
    let internalCode = item.internalCode;
    let tmp$3;
    tmp$3 = internalCode !== undefined && internalCode !== "" ? JsxRuntime.jsx(TextStyle.make, {
        children: internalCode,
        variation: "subdued"
      }) : null;
    tmp = JsxRuntime.jsxs(Stack.make, {
      children: [
        tmp$1,
        tmp$2,
        tmp$3
      ],
      space: "xxsmall"
    });
  }
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(TextStyle.make, {
              children: item.companyName,
              weight: "strong"
            }),
            email !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                children: email
              }) : null,
            phoneNumber !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                children: phoneNumber
              }) : null,
            mobileNumber !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                children: mobileNumber
              }) : null
          ],
          space: "xxsmall"
        }),
        tmp
      ],
      space: "medium"
    }),
    title: I18n.t("Company information"),
    action: {
      icon: "legacy_edit",
      title: I18n.t("Edit information"),
      href: props.supplierEditRoute(props.id)
    }
  });
}

let SupplierInformationsCard = {
  make: SupplierShowPage$SupplierInformationsCard
};

function postalCodeCityCountry(postalCode, city, country, param) {
  let cityCountry = Stdlib_Array.filterMap([
    city,
    country
  ], maybeString => {
    if (maybeString !== undefined && maybeString !== "") {
      return maybeString;
    }
  }).join(", ");
  let exit = 0;
  if (postalCode !== undefined && postalCode !== "") {
    if (cityCountry === "") {
      return postalCode;
    }
  } else {
    exit = 2;
  }
  if (exit === 2 && cityCountry === "") {
    return;
  }
  if (postalCode !== undefined && postalCode !== "") {
    return postalCode + " " + cityCountry;
  } else {
    return cityCountry;
  }
}

let cartTitle = I18n.t("Location");

function SupplierShowPage$SupplierLocationCard(props) {
  let href = props.supplierEditLocationRoute(props.id);
  let match = props.items[0];
  if (match === undefined) {
    return JsxRuntime.jsx(Card.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Location information not specified"),
        variation: "subdued"
      }),
      title: cartTitle,
      action: {
        icon: "legacy_edit",
        title: I18n.t("New location"),
        href: href
      }
    });
  }
  let address = match.address;
  let recipient = match.recipient;
  let tmp;
  tmp = recipient !== undefined && recipient !== "" ? JsxRuntime.jsx(TextStyle.make, {
      children: recipient
    }) : null;
  let tmp$1;
  tmp$1 = address !== undefined && address !== "" ? JsxRuntime.jsx(TextStyle.make, {
      children: address
    }) : null;
  let postalCodeCityCountry$1 = postalCodeCityCountry(match.postalCode, match.city, match.country, undefined);
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: match.label,
          variation: "normal"
        }),
        tmp,
        tmp$1,
        postalCodeCityCountry$1 !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: postalCodeCityCountry$1
          }) : null
      ],
      space: "xxsmall"
    }),
    title: cartTitle,
    action: {
      icon: "legacy_edit",
      title: I18n.t("Edit location"),
      href: href
    }
  });
}

let SupplierLocationCard = {
  postalCodeCityCountry: postalCodeCityCountry,
  cartTitle: cartTitle,
  make: SupplierShowPage$SupplierLocationCard
};

function title(lastName, civility, firstName, param) {
  return Stdlib_Array.filterMap([
    Stdlib_Option.map(civility, SupplierCivility.toShortLabel),
    firstName,
    lastName
  ], maybeString => maybeString).join(" ");
}

let cardTitle = I18n.t("Contact");

function SupplierShowPage$SupplierContactCard(props) {
  let __items = props.items;
  let items = __items !== undefined ? __items : [];
  let href = props.supplierEditContactRoute(props.id);
  let match = items[0];
  if (match === undefined) {
    return JsxRuntime.jsx(Card.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Contact information not specified"),
        variation: "subdued"
      }),
      title: cardTitle,
      action: {
        icon: "legacy_edit",
        title: I18n.t("New contact"),
        href: href
      }
    });
  }
  let mobileNumber = match.mobileNumber;
  let phoneNumber = match.phoneNumber;
  let position = match.position;
  let email = match.email;
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: title(match.lastName, match.civility, match.firstName, undefined),
          weight: "strong"
        }),
        position !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: position
          }) : null,
        email !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: email
          }) : null,
        phoneNumber !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: phoneNumber
          }) : null,
        mobileNumber !== undefined ? JsxRuntime.jsx(TextStyle.make, {
            children: mobileNumber
          }) : null
      ],
      space: "xxsmall"
    }),
    title: cardTitle,
    action: {
      icon: "legacy_edit",
      title: I18n.t("Edit contact"),
      href: href
    }
  });
}

let SupplierContactCard = {
  title: title,
  cardTitle: cardTitle,
  make: SupplierShowPage$SupplierContactCard
};

function SupplierShowPage$SupplierTotalPurchasedCard(props) {
  let __currency = props.currency;
  let currency = __currency !== undefined ? __currency : "EUR";
  let value = Stdlib_Option.getOr(Stdlib_Float.fromString(props.value.slice(0, -1).replace(",", ".")), 0);
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(ValueIndicator.make, {
      value: {
        NAME: "currency",
        VAL: [
          value,
          currency
        ]
      }
    }),
    title: I18n.t("Amount of orders received including VAT"),
    grow: true
  });
}

let SupplierTotalPurchasedCard = {
  make: SupplierShowPage$SupplierTotalPurchasedCard
};

function SupplierShowPage$SupplierOrderTableCard(props) {
  let onRequestNotification = props.onRequestNotification;
  let authScope = Auth.useScope();
  let match = Navigation.useUrl();
  let placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
    status: "NoDataAvailable",
    customText: I18n.t("No order has been recorded yet")
  });
  let columns = [
    {
      key: "order-formatted-name",
      name: I18n.t("Number"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 140
        },
        width: {
          NAME: "pct",
          VAL: 30
        },
        margin: "normal"
      },
      render: param => {
        let match = param.data;
        let allShopsFiltered;
        allShopsFiltered = authScope.TAG === "Organisation" ? authScope.activeShop === undefined : false;
        let shopName = allShopsFiltered ? match.shopName : undefined;
        return JsxRuntime.jsx(OrderNameTableCell.make, {
          value: match.formattedName,
          shopName: shopName,
          id: match.id
        });
      }
    },
    {
      key: "issue-date",
      name: I18n.t("Reception date"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        },
        width: {
          NAME: "fr",
          VAL: 1.7
        }
      },
      render: param => {
        let match = param.data;
        let receptionFinishedAt = match.receptionFinishedAt;
        if (receptionFinishedAt !== undefined) {
          return JsxRuntime.jsx(TableDateCell.make, {
            value: receptionFinishedAt
          });
        } else {
          return JsxRuntime.jsx(TableDateCell.make, {
            value: match.estimatedReceptionDate,
            label: I18n.t("estimated")
          });
        }
      }
    },
    {
      key: "total-excl-vat",
      name: I18n.t("Amount VAT excl."),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => {
        let order = param.data;
        return JsxRuntime.jsx(AmountTableCell.make, {
          value: order.totalAmountExcludingTaxes,
          secondaryValue: order.totalAmountIncludingTaxes,
          decimalPrecision: 3
        });
      }
    },
    {
      key: "quantity",
      name: I18n.t("Quantity"),
      layout: {
        alignX: "center"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.totalProductsQuantity.toString()
      })
    },
    {
      key: "status",
      name: I18n.t("Status"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        width: {
          NAME: "fr",
          VAL: 2
        }
      },
      render: param => JsxRuntime.jsx(OrderStatusBadges.make, {
        statuses: param.data.formattedStatus
      })
    },
    {
      key: "actions",
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 60
        },
        width: {
          NAME: "px",
          VAL: 60
        },
        alignX: "flexEnd",
        sticky: true
      },
      render: param => {
        let order = param.data;
        return JsxRuntime.jsx(Offset.make, {
          children: JsxRuntime.jsx(OrderTableActions.make, {
            id: order.id,
            name: order.formattedName,
            statuses: order.formattedStatus,
            onRequestNotification: onRequestNotification
          }),
          right: -6,
          width: 48,
          height: 32
        });
      }
    }
  ];
  return JsxRuntime.jsxs(Card.make, {
    children: [
      JsxRuntime.jsx(TableView.make, {
        data: {
          TAG: "Done",
          _0: {
            TAG: "Ok",
            _0: props.rows
          }
        },
        columns: columns,
        keyExtractor: row => row.id,
        placeholderEmptyState: placeholderEmptyState
      }),
      props.hasNextPage ? JsxRuntime.jsx(ShowAllDataLink.make, {
          href: match.pathname + OrderRoutes.baseRoute
        }) : null
    ],
    title: I18n.t("Orders history"),
    action: props.status === "UNARCHIVED" ? ({
        icon: "legacy_plus",
        title: I18n.t("Create order"),
        href: OrderRoutes.createRoute + "?" + OrderUrlQueryString.CreateOrder.encode({
          supplierId: props.id,
          shopId: props.shopId
        })
      }) : undefined,
    variation: "table",
    grow: true
  });
}

let SupplierOrderTableCard = {
  make: SupplierShowPage$SupplierOrderTableCard
};

function SupplierShowPage(props) {
  let scope = Auth.useScope();
  let match = React.useState(() => {});
  let setNotification = match[1];
  let notification = match[0];
  let asyncResultSupplier = AsyncResult.mapError(AsyncResult.mapOk(ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: props.id,
    ordersFirst: 5
  })), param => param.supplier), param => {});
  let formId;
  if (typeof asyncResultSupplier !== "object") {
    formId = undefined;
  } else if (asyncResultSupplier.TAG === "Reloading") {
    let match$1 = asyncResultSupplier._0;
    if (match$1.TAG === "Ok") {
      let supplier = match$1._0;
      formId = supplier !== undefined ? supplier.id : undefined;
    } else {
      formId = undefined;
    }
  } else {
    let match$2 = asyncResultSupplier._0;
    if (match$2.TAG === "Ok") {
      let supplier$1 = match$2._0;
      formId = supplier$1 !== undefined ? supplier$1.id : undefined;
    } else {
      formId = undefined;
    }
  }
  let formInitialValues;
  let exit = 0;
  let supplier$2;
  if (typeof asyncResultSupplier !== "object") {
    formInitialValues = {
      note: ""
    };
  } else if (asyncResultSupplier.TAG === "Reloading") {
    let match$3 = asyncResultSupplier._0;
    if (match$3.TAG === "Ok") {
      let supplier$3 = match$3._0;
      if (supplier$3 !== undefined) {
        supplier$2 = supplier$3;
        exit = 1;
      } else {
        formInitialValues = {
          note: ""
        };
      }
    } else {
      formInitialValues = {
        note: ""
      };
    }
  } else {
    let match$4 = asyncResultSupplier._0;
    if (match$4.TAG === "Ok") {
      let supplier$4 = match$4._0;
      if (supplier$4 !== undefined) {
        supplier$2 = supplier$4;
        exit = 1;
      } else {
        formInitialValues = {
          note: ""
        };
      }
    } else {
      formInitialValues = {
        note: ""
      };
    }
  }
  if (exit === 1) {
    let note = Stdlib_Option.getOr(supplier$2.note, "");
    formInitialValues = {
      note: note
    };
  }
  let formPropState = SupplierNoteEditForm.useFormPropState({
    id: formId,
    initialValues: formInitialValues,
    schema: [],
    resetValuesAfterSubmission: true
  });
  let exit$1 = 0;
  let supplier$5;
  if (typeof asyncResultSupplier !== "object") {
    if (asyncResultSupplier === "NotAsked") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
    exit$1 = 2;
  } else if (asyncResultSupplier.TAG === "Reloading") {
    let match$5 = asyncResultSupplier._0;
    if (match$5.TAG === "Ok") {
      let supplier$6 = match$5._0;
      if (supplier$6 !== undefined) {
        supplier$5 = supplier$6;
        exit$1 = 1;
      } else {
        exit$1 = 2;
      }
    } else {
      exit$1 = 2;
    }
  } else {
    let match$6 = asyncResultSupplier._0;
    if (match$6.TAG !== "Ok") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
    let supplier$7 = match$6._0;
    if (supplier$7 === undefined) {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "NoDataAvailable"
      });
    }
    supplier$5 = supplier$7;
    exit$1 = 1;
  }
  switch (exit$1) {
    case 1 :
      let match$7 = supplier$5.shop;
      let shopId = match$7.id;
      let id = supplier$5.id;
      let match$8 = supplier$5.archivedAt;
      let status = match$8 !== undefined ? "ARCHIVED" : "UNARCHIVED";
      let subtitle;
      subtitle = scope.TAG === "Organisation" ? match$7.name : undefined;
      let actionsBar = JsxRuntime.jsx(SupplierShowPage$SupplierMenuActions, {
        id: id,
        shopId: shopId,
        status: status,
        supplierBaseRoute: props.supplierBaseRoute
      });
      let statusBadge = JsxRuntime.jsx(SupplierShowPage$SupplierStatusBadge, {
        status: status
      });
      let notificationBanner = notification !== undefined ? JsxRuntime.jsx(ResourceDetailsPage.NotificationBanner.make, {
          value: notification,
          onRequestClose: () => setNotification(param => {})
        }) : null;
      return JsxRuntime.jsx(SupplierNoteEditForm.Core.Provider.make, {
        children: JsxRuntime.jsx(ResourceDetailsPage.make, {
          title: supplier$5.companyName,
          subtitle: subtitle,
          actionsBar: actionsBar,
          notificationBanner: notificationBanner,
          statusBadge: statusBadge,
          children: JsxRuntime.jsxs(Group.make, {
            children: [
              JsxRuntime.jsxs(Stack.make, {
                children: [
                  JsxRuntime.jsx(SupplierShowPage$SupplierTotalPurchasedCard, {
                    value: supplier$5.formattedOrdersTotalAmountIncludingTaxes
                  }),
                  JsxRuntime.jsx(SupplierShowPage$SupplierInformationsCard, {
                    id: id,
                    item: supplier$5,
                    supplierEditRoute: props.supplierEditRoute
                  }),
                  JsxRuntime.jsx(SupplierShowPage$SupplierLocationCard, {
                    id: id,
                    supplierEditLocationRoute: props.supplierEditLocationRoute,
                    items: supplier$5.locations.edges.map(param => param.node)
                  }),
                  JsxRuntime.jsx(SupplierShowPage$SupplierContactCard, {
                    id: id,
                    supplierEditContactRoute: props.supplierEditContactRoute,
                    items: supplier$5.contacts.edges.map(param => param.node)
                  }),
                  JsxRuntime.jsx(Card.make, {
                    children: JsxRuntime.jsx(SupplierNoteEditForm.InputTextArea.make, {
                      field: "Note",
                      label: I18n.t("Note")
                    }),
                    title: I18n.t("Note")
                  })
                ],
                space: "large"
              }),
              JsxRuntime.jsx(SupplierShowPage$SupplierOrderTableCard, {
                id: id,
                shopId: shopId,
                rows: supplier$5.orders.edges.map(param => {
                  let order = param.node;
                  return {
                    id: order.id,
                    formattedName: order.formattedName,
                    shopName: order.shop.name,
                    estimatedReceptionDate: order.estimatedReceptionDate,
                    receptionFinishedAt: order.receptionFinishedAt,
                    totalAmountExcludingTaxes: order.totalAmountExcludingTaxes,
                    totalAmountIncludingTaxes: order.totalAmountIncludingTaxes,
                    totalProductsQuantity: order.totalProductsQuantity,
                    formattedStatus: order.formattedStatus
                  };
                }),
                hasNextPage: Stdlib_Option.getOr(supplier$5.orders.pageInfo.hasNextPage, false),
                status: status,
                onRequestNotification: notification => setNotification(param => notification)
              })
            ],
            grid: [
              "30%",
              "70%"
            ],
            wrap: false,
            grow: false,
            spaceX: "large"
          })
        }),
        propState: formPropState
      });
    case 2 :
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
  }
}

let make = SupplierShowPage;

export {
  SupplierQuery,
  SupplierEditNoteMutation,
  SupplierUnarchiveMutation,
  SupplierStatusBadge,
  SupplierNoteEditFormLenses_,
  SupplierNoteEditFormLenses,
  SupplierNoteEditForm,
  SupplierMenuEditingActions,
  SupplierMenuReadingActions,
  SupplierMenuActions,
  SupplierInformationsCard,
  SupplierLocationCard,
  SupplierContactCard,
  SupplierTotalPurchasedCard,
  SupplierOrderTableCard,
  make,
}
/* query Not a pure module */
